import gql from 'graphql-tag';
import { Fragments } from '@shared/api';

export const inviteLink = gql`
  query BusinessInviteLinkQuery($businessId: Int!) {
    inviteCode: legacyUserShareCode(businessId: $businessId)
    business: getBusiness(id: $businessId) {
      ...Business
    }
  }

  ${Fragments.business.business}
`;

export const getBusiness = gql`
  query GetBusinessQuery($id: Int!) {
    business: getBusiness(id: $id) {
      ...Business
    }
  }

  ${Fragments.business.business}
`;

/**
 * Org login user-picker. `myBusiness` has no arguments — business scope comes from the
 * business JWT and `x-coast-business-id`. Do not pass `businessId` into the field; the
 * server resolves context from the token.
 */
export const getBusinessLoginPeople = gql`
  query GetBusinessLoginPeopleQuery {
    business: myBusiness {
      ...Business
      users {
        id
        firstName
        lastName
        img
        hasPasscode
        lastVisitedAt
        lastRemindedAt
        createdAt
      }
    }
  }

  ${Fragments.business.business}
`;

/** Create-account flow while signed in with a business token only. */
export const getBusinessUserCreate = gql`
  query GetBusinessUserCreateQuery($id: Int!) {
    business: getBusiness(id: $id) {
      ...Business
    }
  }

  ${Fragments.business.business}
`;

export const listBusinesses = gql`
  query ListBusinessesQuery($input: ListBusinesses!) {
    listBusinesses(input: $input) {
      businesses {
        ...Business
      }
      hasMore
    }
  }

  ${Fragments.business.business}
`;

export const getBusinessMembership = gql`
  query GetBusinessMembershipQuery($userId: Int!) {
    getBusinessMembership(userId: $userId) {
      businessId
      role
      userId
    }
  }
`;

export const listBusinessMemberships = gql`
  query ListBusinessMembershipsQuery($input: ListBusinessMemberships!) {
    listBusinessMemberships(input: $input) {
      businessMemberships {
        businessId
        role
        userId
      }
      hasMore
    }
  }
`;

export const legacyListBusinessUnreadCounts = gql`
  query LegacyListBusinessUnreadCountsQuery {
    legacyListBusinessUnreadCounts {
      businessId
      unreadCount
    }
  }
`;
